import { useContext } from 'react';

import { WWContext, type WWContextValue } from '../components/WWContext';

import { isWwsWeddingWebsiteV2 } from '../types/graphql';

import type { Wws_Page } from '../types/graphql';

export const LITE_SITE_TYPE = 'LiteSitePage';

export function useIsLiteSite(): boolean {
  const { data } = useContext<WWContextValue>(WWContext);

  if (isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    return Boolean(
      data?.weddingWebsiteResult.pages?.find(
        (page: Wws_Page): boolean => page.type === LITE_SITE_TYPE
      )
    );
  }

  return false;
}
